import { ILoaiGioHocActionTypes } from "../../action-types/category/ILoaiGioHocActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILoaiGioHocReducer } from "../../reducer-model/category/ILoaiGioHocReducer";

const initState: ILoaiGioHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiGioHocs: [],
};
export const loaiGioHocReducer = (
  state: ILoaiGioHocReducer = initState,
  action: ILoaiGioHocActionTypes
): ILoaiGioHocReducer => {
  switch (action.type) {
    case "LOAI_GIO_HOC_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "LOAI_GIO_HOC_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, loaiGioHocs: action.payload };
    case "LOAI_GIO_HOC_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "LOAI_GIO_HOC_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, loaiGioHocEditing: action.payload };
    case "LOAI_GIO_HOC_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "LOAI_GIO_HOC_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "LOAI_GIO_HOC_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "LOAI_GIO_HOC_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "LOAI_GIO_HOC_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "LOAI_GIO_HOC_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "LOAI_GIO_HOC_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
